import { render } from "./Geopolitics.vue?vue&type=template&id=d860c602"
import script from "./Geopolitics.vue?vue&type=script&lang=js"
export * from "./Geopolitics.vue?vue&type=script&lang=js"

import "./Geopolitics.vue?vue&type=style&index=0&id=d860c602&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__